import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import CreateEventForm from '../components/CreateEventForm';
import { getEventByEventId } from '../services/event-services';
import { refreshAuthToken } from '../services/auth-services';

function EditEvent(props) {
    let { eventId } = useParams(); 
    const [eventData, setEventData] = useState()
    const [loading, setLoading] = useState(true)
    const [refreshToken, setRefreshToken] = useState()
    useEffect(() => {
        const loadVenues = async () => {
          refreshAuthToken().then(token => {
            setRefreshToken(token)
            getEventByEventId(eventId, token).then(response => {
              var responseJson = response.data;
              setEventData(responseJson)
              console.log(responseJson)
              setLoading(false)
          })
          })
              
        }
        loadVenues();
      }, [eventId])
  return (
    <Container style={{backgroundRepeat:"no-repeat",backgroundSize:"auto", height:"130vh", backgroundColor:"#091440", backgroundPosition:"top", color:"white"}} fluid>
    <Row>
      <Col>
        <h1>Edit Event</h1>
        { !loading ? <CreateEventForm eventData={eventData} refreshToken={refreshToken}/> : "" }
      </Col>
    </Row>
  </Container>
  );
}

export default EditEvent